"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilter = void 0;
const react_1 = require("react");
const predicate_language_1 = require("@groupby/predicate-language");
const react_router_1 = require("react-router");
const use_filter_utils_1 = require("./use-filter.utils");
const hooks_1 = require("./");
const use_filter_utils_2 = require("./use-filter.utils");
const router_1 = require("../../router");
const selectors_1 = require("../../store/selectors");
const State = __importStar(require("../../store/state"));
const useFilter = ({ activeTab = 2 /* TABS.All */, searchFilter = new predicate_language_1.PredicateBuilder(), }) => {
    const enrichDrawerRoutes = (0, router_1.getEnrichDrawerRoutes)();
    const { pathname } = (0, react_router_1.useLocation)();
    const includedCategoriesIds = (0, selectors_1.useProductsIncludedCategoriesIds)();
    const excludedCategoriesIds = (0, selectors_1.useProductsExcludedCategoriesIds)();
    const includedAttributesIds = (0, selectors_1.useProductsIncludedAttributesIds)();
    const excludedAttributesIds = (0, selectors_1.useProductsExcludedAttributesIds)();
    const selectedOrganizations = (0, selectors_1.useSelectedOrganizationsSelector)();
    const selectedOrganizationsIds = (0, selectors_1.useSelectedOrganizationsIdsSelector)();
    const includedTaxonomyClassIds = (0, selectors_1.useProductsIncludedTaxonomyClassIds)();
    const excludedTaxonomyClassIds = (0, selectors_1.useProductsExcludedTaxonomyClassIds)();
    const productActiveFilter = (0, selectors_1.useProductsFilterActive)();
    const productActiveOperator = (0, selectors_1.useProductsFilterOperator)();
    const { advancedFilter } = (0, hooks_1.useViewerTableFilter)();
    const filterRefinements = (0, react_1.useMemo)(() => {
        const logicalOperator = (0, use_filter_utils_1.getLogicalOperator)(productActiveOperator);
        const inclusionFilter = new predicate_language_1.PredicateBuilder();
        inclusionFilter[logicalOperator]((0, use_filter_utils_2.createCategoryInclusionsFilter)(includedCategoriesIds, logicalOperator));
        inclusionFilter[logicalOperator]((0, use_filter_utils_2.createClassesInclusionsFilter)(includedTaxonomyClassIds, logicalOperator));
        inclusionFilter[logicalOperator]((0, use_filter_utils_2.createAttributeInclusionsFilter)(includedAttributesIds, logicalOperator));
        const exclusionFilter = new predicate_language_1.PredicateBuilder();
        exclusionFilter.and((0, use_filter_utils_2.createCategoryExclusionsFilter)(excludedCategoriesIds));
        exclusionFilter.and((0, use_filter_utils_2.createClassesExclusionsFilter)(excludedTaxonomyClassIds));
        exclusionFilter.and((0, use_filter_utils_2.createAttributeExclusionsFilter)(excludedAttributesIds));
        return (0, predicate_language_1.where)(inclusionFilter).and((0, predicate_language_1.where)(exclusionFilter));
    }, [
        excludedAttributesIds,
        excludedCategoriesIds,
        excludedTaxonomyClassIds,
        includedAttributesIds,
        includedCategoriesIds,
        includedTaxonomyClassIds,
        productActiveOperator
    ]);
    const getFilters = (0, react_1.useCallback)(() => {
        const filter = new predicate_language_1.PredicateBuilder();
        if (productActiveFilter !== State.ProductFilterActiveTypes.All) {
            filter.and((0, predicate_language_1.where)((0, predicate_language_1.f) `active`, '==', productActiveFilter === State.ProductFilterActiveTypes.Active));
        }
        if (searchFilter.expressionTree.children.length) {
            filter.and((0, predicate_language_1.where)(searchFilter));
        }
        if (advancedFilter.expressionTree.children.length && pathname === enrichDrawerRoutes.viewer.path) {
            filter.and((0, predicate_language_1.where)(advancedFilter));
        }
        const classifiedFilter = (0, predicate_language_1.where)((0, predicate_language_1.f) `classId`, '!=', null);
        const notClassifiedFilter = (0, predicate_language_1.where)((0, predicate_language_1.f) `classId`, '==', null);
        filter.and(filterRefinements);
        filter.and((0, predicate_language_1.where)((0, predicate_language_1.f) `organizationId`, '@<', selectedOrganizations.map(({ id }) => (0, predicate_language_1.uuid)(id))));
        return {
            filter: filter.expressionTree.children.length ? filter : undefined,
            classifiedFilter: (0, predicate_language_1.where)(classifiedFilter).and(filter),
            unclassifiedFilter: notClassifiedFilter.and(filter),
        };
    }, [productActiveFilter, searchFilter, selectedOrganizationsIds, filterRefinements, advancedFilter]);
    const activeFilter = (0, react_1.useMemo)(() => {
        const { filter, classifiedFilter, unclassifiedFilter } = getFilters();
        switch (activeTab) {
            case 0 /* TABS.Unclassified */:
                return unclassifiedFilter;
            case 1 /* TABS.Classified */:
                return classifiedFilter;
            case 2 /* TABS.All */:
                return filter;
            default:
                return undefined;
        }
    }, [activeTab, getFilters]);
    return { activeFilter, getFilters };
};
exports.useFilter = useFilter;
